import { BUSINESS_VERTICAL, EVENT_CATEGORY } from '../../constants/EventHelper'
import { getCommonParams } from '../CommonParams'
import { EVENT_PARAM_KEY as EPK } from '../../constants/EventParamKey'
import {
  BannerClickedEventParams,
  BannerContentInterface,
} from '../../events/banner/BannerClickedEvent'

const CONTENT_TYPE = {
  STATIC: 'static',
  GIF: 'gif',
  VIDEO: 'video',
}

const BANNER_TYPE = {
  CAROUSEL: 'carousel',
  FIXED: 'fixed',
}

interface BannerInput {
  source?: string | null
  campaignName?: string | null
  adId?: string | null
  name?: string | null
  imageUrl: string
  position?: number | null
  bannerType: string
  type?: string
  link: string
  duration?: number | null
  redeemedStatus?: boolean | null
  dwellTime?: string | number | null
}

export const createBannerClickedEventParams = (
  banner: BannerInput,
  businessVertical: string = BUSINESS_VERTICAL.GROCERY,
  eventCategory: string = EVENT_CATEGORY.BANNER
): BannerClickedEventParams => {
  const {
    source = null,
    campaignName = null,
    adId = null,
    name = null,
    imageUrl = null,
    position = null,
    bannerType = null,
    type = CONTENT_TYPE.STATIC,
    link = null,
    duration = 0,
    redeemedStatus = null,
    dwellTime = null,
  } = banner || {}

  const isOsmos = source?.toLowerCase() === 'osmos'
  const contentType = [
    CONTENT_TYPE.STATIC,
    CONTENT_TYPE.GIF,
    CONTENT_TYPE.VIDEO,
  ].includes(type)
    ? type
    : CONTENT_TYPE.STATIC

  let contentBannerType = null
  if (isOsmos) {
    contentBannerType =
      bannerType === 'BIG' ? BANNER_TYPE.CAROUSEL : BANNER_TYPE.FIXED
  }

  const content: BannerContentInterface = {
    [EPK.BANNER_CONTENT.SOURCE]: source,
    [EPK.BANNER_CONTENT.CAMPAIGN_NAME]: isOsmos ? campaignName : null,
    [EPK.BANNER_CONTENT.NAME]: isOsmos ? name : null,
    [EPK.BANNER_CONTENT.ID]: adId,
    [EPK.BANNER_CONTENT.LINK]: imageUrl,
    [EPK.BANNER_CONTENT.POSITION]: position ?? 0,
    [EPK.BANNER_CONTENT.BANNER_TYPE]: contentBannerType,
    [EPK.BANNER_CONTENT.TYPE]: contentType,
    [EPK.BANNER_CONTENT.DESTINATION_URL]: link,
    [EPK.BANNER_CONTENT.DURATION]: duration ?? 0,
    [EPK.BANNER_CONTENT.REDEEMED_STATUS]: redeemedStatus,
    [EPK.BANNER_CONTENT.DWELL_TIME]: dwellTime,
  }

  return {
    ...getCommonParams(),
    SCREEN_SECTION: null,
    BUSINESS_VERTICAL: businessVertical,
    EVENT_CATEGORY: eventCategory,
    CONTENT: content,
  }
}
